import { IsEmpty, IsValidEmail, passwordStrength,
} from "../../utils/helper";

export default function IsValidSignUpData(data) {
  let errors = {};

if ('first_name' in data) {
  const firstName = data?.first_name?.trim();
  const nameRegex = /^[A-Za-z]+(\s[A-Za-z]+)*$/; 

  if (IsEmpty(firstName)) {
    errors.first_name = "First name is required";
  } else if (!nameRegex.test(firstName)) {
    errors.first_name = "First name must only contain letters";
  } else if (firstName.length < 3 || firstName.length > 30) {
    errors.first_name = "First name must be between 3 and 30 characters";
  }
}

if ('last_name' in data) {
  const lastName = data?.last_name?.trim();
  const nameRegex = /^[A-Za-z]+(\s[A-Za-z]+)*$/;

  if (IsEmpty(lastName)) {
    errors.last_name = "Last name is required";
  } else if (!nameRegex.test(lastName)) {
    errors.last_name = "Last name must only contain letters";
  } else if (lastName.length < 3 || lastName.length > 30) {
    errors.last_name = "Last name must be between 3 and 30 characters";
  }
}



  if ('agree_to_terms' in data) {
    if (data?.agree_to_terms === false) {
      errors.agree_to_terms = true;
    }
  }

  if ('how_did_you_hear' in data) {
    if (IsEmpty(data?.how_did_you_hear)) {
      errors.how_did_you_hear = "How you found us is required";
    }
  }

if ('email' in data) {
  const email = data?.email?.trim();

if (IsEmpty(email)) {
  errors.email = "Email is required";
} else {
  const trimmedEmail = email.trim();
  
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!emailRegex.test(trimmedEmail)) {
    errors.email = "Invalid email format";
  } else if (trimmedEmail.length > 254) {
    errors.email = "Email is too long";
  } else if (trimmedEmail.includes("..")) {
    errors.email = "Email cannot contain consecutive dots";
  } else if (trimmedEmail.startsWith(".") || trimmedEmail.includes("@.") || trimmedEmail.includes(".@")) {
    errors.email = "Invalid email format";
  }
}
}



  if ('phone_number' in data) {
    const selectedCountry = data?.country_region;
    let phoneWithCountryCode = data.phone_number?.startsWith('+')
     && data?.phone_number
  
    if (IsEmpty(data?.phone_number)) {
      errors.phone_number = "Phone number is required";
    } 

    else if (!data.phone_number.startsWith('+') && !/^\d{10}$/.test(data.phone_number)) {
      errors.phone_number = "Phone number must be 10 digits";
    } 
    else if (!/^\+1\d{10}$|^\+44\d{10}$|^\+1\d{10}$/.test(phoneWithCountryCode)) {
      errors.phone_number = "Invalid phone number!";
    } 
    else if (
      (selectedCountry === "United States of America" && !data.phone_number.startsWith("+1")) ||
      (selectedCountry === "Canada" && !data.phone_number.startsWith("+1")) ||
      (selectedCountry === "United Kingdom" && !data.phone_number.startsWith("+44"))
    ) {
      let correctCode = selectedCountry === "United Kingdom" ? '+44' : '+1';
      errors.phone_number = `Phone number must start with the correct country code(${correctCode}) for ${selectedCountry}.`;
    } 
    else {
      data.phone_number = phoneWithCountryCode;
    }
  }
  
  
  
  
  

  if ('password' in data) {
    if (IsEmpty(data?.password)) {
      errors.password = "Password is required";
    } else if (data?.password.length < 6 || data?.password.length > 15) {
      errors.password = "Password must be between 6 and 15 characters";
    } else {
      let strength = passwordStrength(data?.password);
      if (strength !== 'STRONG') errors.password = strength;
    }
  }

  if ('confirm_password' in data) {
    if (IsEmpty(data?.confirm_password)) {
      errors.confirm_password = "Confirm Password is required";
    } else if (data?.password !== data?.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }
  }

  return {
    isValid: IsEmpty(errors),
    errors: errors,
  };
}
